import styled from '@emotion/styled';

const CurrencyFlagCircularStyle = styled.div`
  display: grid;

  & > div {
    object-fit: none;
    object-position: 50% 50%;
    border-radius: 100%;
    width: 20px;
    height: 20px;
    background-position: center;
  }
`;

export default CurrencyFlagCircularStyle;
